import { Theme, makeStyles } from '@material-ui/core/styles';
import { PrimaryColors, SecondaryColors, SurfaceColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    backgroundColor: SurfaceColors.light,
    color: TextColors.dark,

    '& $icon': {
      color: SecondaryColors.main,
    },
  },
};

const darkTheme = {
  root: {
    backgroundColor: PrimaryColors.light,
    color: TextColors.light,

    '& $icon': {
      color: SecondaryColors.main,
    },
  },
};

export interface StyleProps {
  numOfCTAs: number;
}

const useStyles = makeStyles<Theme, StyleProps>(
  (muiTheme) => ({
    root: {
      alignItems: 'center',
      display: 'flex !important',
      height: '100%',
      justifyContent: 'space-between',
      padding: '10px 20px',
      textAlign: 'center',
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '& img': {
        maxWidth: '100%',
        display: 'block',
      },
      '& .MuiSvgIcon-root': {
        marginRight: '-4px',
      },
    },
    icon: {},
    img: {
      height: '36px',
    },
    column: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: ({ numOfCTAs }) => '1fr '.repeat(numOfCTAs),
      gap: '20px 0',
      height: '100%',
      [muiTheme.breakpoints.up('md')]: {
        gap: '40px 0',
      },
    },
    item: {
      height: '100%',
    },
  }),
  {
    name: 'GenSmallCTATile',
  },
);

export default useStyles;
